import { useCallback } from 'react';
import connect from 'Shared/connect';
import { addToCart } from './../../../Cart/action-creators';
import { getCartLineItemCountForVariant } from '../../../Cart/reducer';
import { getSelectedVariant } from 'Shared/Product/reducer';
import { getStepSize as getQuantityStepSize } from 'Shared/Quantity/utils';
import { componentIsSupplierAdPage } from './../../../Ad/Pages/SupplierAd/current-page-is-supplieradpage';
import { isLinkVisible } from 'Shared/ProductAlternativesLink/ProductAlternativesLink';
export const getAddToCartExperiment = (selectedVariant, product) => {
    if (!isLinkVisible(selectedVariant, product))
        return null;
    const body = document.querySelector('body');
    const experimentName = !!body.getAttribute("data-experiment-name") ? body.getAttribute("data-experiment-name") : "Experiment";
    const experimentType = body.getAttribute("data-experiment-type") == 'B' ? 'B' : "A";
    return experimentName + "-" + experimentType;
};
const ProductCardContainer = ({ index, product, cardHeight, quantityInCart, selectedVariant, addToCart, isRestrictedCustomer, cardType, isSupplierAdPage, isRecommendationsPanel, addToCartLocation, addToCartGa4TrackingContext, children, }) => {
    const discontinuedOrBackordered = product.isDiscontinued || product.isBackorderReplaced;
    const quantityStep = getQuantityStepSize(selectedVariant);
    const url = product.isDiscontinued && product.replacementProduct
        ? product.replacementProduct.url.toString()
        : !product.isDiscontinued && product.url.toString();
    const getAddToCartLocation = () => {
        if (addToCartLocation) {
            return addToCartLocation;
        }
        return !!isSupplierAdPage
            ? 'SupplierAd'
            : !!isRecommendationsPanel
                ? 'RecommendationPanel'
                : 'ProductList';
    };
    const updateCartQuantity = useCallback((quantity) => {
        const { code, unitShortName, ticket } = selectedVariant;
        document.dispatchEvent(new CustomEvent("PeeriusTrackingClick", { detail: code }));
        return addToCart(code, quantity, unitShortName, ticket, getAddToCartLocation(), getAddToCartExperiment(selectedVariant, product), addToCartGa4TrackingContext);
    }, [selectedVariant, product, addToCartLocation, addToCartGa4TrackingContext]);
    return children({
        index,
        product,
        quantityInCart,
        selectedVariant,
        updateCartQuantity,
        discontinuedOrBackordered,
        quantityStep,
        url,
        isRestrictedCustomer,
        cardHeight,
        cardType
    });
};
export default connect((state, { product }) => {
    const selectedVariant = getSelectedVariant(state, product.variants);
    return {
        selectedVariant,
        quantityInCart: getCartLineItemCountForVariant(state, selectedVariant),
        isRestrictedCustomer: state.appShellData.currentUser.isRestrictedCustomer,
        isSupplierAdPage: componentIsSupplierAdPage(state.currentPage.componentName),
    };
}, (dispatch) => ({
    addToCart: (code, quantity, unitShortName, ticket, addToCartLocation, experiment, ga4TrackingContext) => dispatch(addToCart(code, quantity, unitShortName, ticket, addToCartLocation, experiment, ga4TrackingContext)),
}))(ProductCardContainer);
